<template>
    <el-drawer :title="formTitle" size="50%" :visible.sync="formVisible">
        <el-form :model="dataForm" ref="dataForm" label-width="120px" :rules="formRules">
            <el-form-item label="完成状态:" prop="Status">
                <enumSelector2
                    :options="$config.traningStatus"
                    style="width: 200px"
                    v-model="dataForm.Status"
                  />
            </el-form-item>
            <el-form-item label="总结说明:" prop="Description">
                <el-input v-model="dataForm.Comment" auto-complete="off" placeholder="请输入情况说明"
                    :disabled="readOnly"></el-input>
            </el-form-item>
            <el-form-item v-if="!readOnly">
                <div class="footer">
                    <el-button type="primary" @click="handleSubmit">提交</el-button>
                </div>
            </el-form-item>
        </el-form>
    </el-drawer>
</template>
<script>
import { save } from "@/api/camp/campAppoint";
import enumSelector2 from "@/components/enumSelector2.vue";
export default {
    components: {
        enumSelector2,
    },
    props: {
    },
    data() {
        return {
            readOnly: false,
            formVisible: false,
            formTitle: "新增",
            dataForm: {
            },
            formRules: {
                Status: [
                    { required: true, message: "请输入名称", trigger: "change" },
                ],
                Comment: [{ required: true, message: "请输入总结", trigger: "change" }],
            },
        };
    },
    methods: {
        handleView(row) {
            this.readOnly = true;
            this.dataForm = JSON.parse(JSON.stringify(row));
            this.formTitle = "查看";
            this.formVisible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        handleCreate() {
            this.formTitle = "新增";
            this.formVisible = true;
            this.readOnly = false;
            this.dataForm = {

            };
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        handleUpdate(row) {
            this.dataForm = JSON.parse(JSON.stringify(row));
            this.readOnly = false;
            this.formTitle = "修改";
            this.formVisible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        handleSubmit: function () {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let data = Object.assign({}, this.dataForm);
                    save(data).then((response) => {
                        if (response) {
                            this.formVisible = false;
                            this.$emit("update");
                        }
                    });
                } else {
                    setTimeout(() => {
                        this.$refs["dataForm"].clearValidate();
                    }, 1000);
                }
            });
        },
    },
    mounted() { },
};
</script>
<style lang='scss' scoped>
/deep/.el-drawer__header {
    margin-bottom: 10px;
    font-size: 16px;
    color: #ff862f;
}

/deep/.el-drawer__body {
    overflow-y: scroll;
}

.footer {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
}

.invoice-container {
    padding: 10px;

    .input {
        width: 150px;
    }

    .tabs-container {
        /deep/.el-tabs--border-card>.el-tabs__content {
            padding: 0;
            height: 1px;
        }

        .tab-content {
            margin-top: -2px;
            border: 1px solid #dcdfe6;
            border-top: 0;
            padding: 15px;
            background: #fff;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
        }
    }
}
</style>